// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.frontProgress{
  position: absolute;
  top: 0px;
}

.iconProgress{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.register-header{
  display: flex;
  justify-content: space-around;
}

.btn {
  width: 60px; /* Cambia '100px' al ancho que prefieras */
  /* height: 50px;  Cambia '50px' a la altura que prefieras */
  display: inline-block;
}

/* Estilos para los botones SÍ/NO en KYC Register */
.btn-outline-dark {
  border: 1px solid #333 !important;
  background-color: white !important;
  color: #333 !important;
  padding: 10px 20px !important;
  font-weight: bold !important;
  font-family: 'Montserrat', sans-serif !important;
}

.btn-outline-dark:hover {
  background-color: #f8f9fa !important;
  border-color: #333 !important;
  color: #333 !important;
}

.btn-dark {
  background-color: #333 !important;
  border: 1px solid #333 !important;
  color: white !important;
  padding: 10px 20px !important;
  font-weight: bold !important;
  font-family: 'Montserrat', sans-serif !important;
}

.btn-dark:hover {
  background-color: #555 !important;
  border-color: #555 !important;
  color: white !important;
}


.custom-checkbox .mat-checkbox-frame {
  border-color: #b0b0b0 !important;
}

.iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
   /* min-height: 90vh; */
}
/* .iframe-container {
width: 100%;
min-height: 90vh;
}

.iframe-container body {
overflow: scroll;
} */
.inputfile {
width: 0.1px;
height: 0.1px;
opacity: 0;
overflow: hidden;
position: absolute;
z-index: -1;
}
.inputfile + label {
cursor: pointer; /* "hand" cursor */
}
.inputfile + label:hover {
background-color: #000000; /* change background color when hover */
}

.card-file{
width: 82px;
height: 82px;
background-color: #ededed;
border-radius: 6px;
position: relative;
}

.add-file{
width: 82px;
height: 82px;
background-color: transparent;
border: 1px solid #ff9600;
border-radius: 6px;
position: relative;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
}

.info-tooltip{
  background-color: #d9d9d9;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: small;
  cursor: pointer;
}

/* Forzamos el ancho del contenedor interno del ng‑select */
.country-prefix-select .ng-select-container {
  width: 100px !important;
  min-width: 100px !important;
  min-height: 45px !important;   /* iguala altura al input .form-control */
  height: 45px !important;
  display: flex !important;
  align-items: center !important; /* centra verticalmente el contenido */
  padding: 0 12px !important;
}

/* Mejora visual del prefijo: separa bandera y código, aumenta legibilidad */
.country-prefix-select .ng-value-label,
.country-prefix-select .ng-option-label {
  margin-left: 6px !important; /* espacio tras la bandera */
  letter-spacing: 0.3px;
}
.country-prefix-select .flag-icon {
  margin-right: 6px;
}
.country-prefix-select .ng-select-container {
  font-size: 0.95rem; /* hace el prefijo ligeramente mayor en móvil y desktop */
}

/* Alinear prefijo y número en la misma línea solo en móvil */
@media screen and (max-width: 480px) {
  .row.my-5.pb-4 {
    align-items: flex-start !important; /* alinea por la parte superior para evitar saltos visuales */
  }
  .row.my-5.pb-4 .col-auto,
  .row.my-5.pb-4 .col {
    padding-bottom: 0 !important;
  }
  .row.my-5.pb-4 label {
    margin-bottom: 4px !important; /* reduce separación label-input */
    min-height: 48px;               /* iguala altura de labels (maneja casos de 1-2 líneas) */
    display: block;
  }
  /* Reserva espacio fijo para el mensaje de error del teléfono y evita saltos */
  .row.my-5.pb-4 .col input.form-control {
    margin-bottom: 32px !important; /* reserva extra para mensajes de varias líneas */
  }
  .row.my-5.pb-4 .col .text-danger.mt-1 {
    min-height: 28px; /* altura mínima para 2 líneas de error */
    display: block;
  }
  .row.my-5.pb-4 .col .text-danger.mt-1 {
    margin-top: 2px !important;
    line-height: 1.2 !important;
  }
}

/* Reset and force ng-select styles */
::ng-deep .ng-select:not(.country-prefix-select) {
  display: block !important;
  width: 100% !important;
}

::ng-deep .ng-select:not(.country-prefix-select) .ng-select-container {
  min-height: 38px !important;
  width: 100% !important;
  position: relative !important;
}

::ng-deep .ng-dropdown-panel {
  position: absolute !important;
  width: 100% !important;
  box-sizing: border-box !important;
  left: 0 !important;
}

::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 100% !important;
}

::ng-deep .ng-select .ng-select-container .ng-value-container {
  width: 100% !important;
  padding: 0.375rem 0.75rem !important;
  box-sizing: border-box !important;
}

::ng-deep .ng-select:not(.country-prefix-select) .ng-dropdown-panel {
  width: 100% !important;
  min-width: 100% !important;
  transform: none !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

::ng-deep .ng-dropdown-panel .scroll-host {
  width: 100% !important;
  min-width: 100% !important;
  box-sizing: border-box !important;
}

::ng-deep .ng-option {
  box-sizing: border-box !important;
  width: 100% !important;
  white-space: normal !important;
  padding: 0.375rem 0.75rem !important;
}

.kyc-loading-message-small {
  display: block;
  margin-top: 6px;
  font-weight: 400;
  line-height: 1.25;
  text-align: center;
  color: #666;
  font-size: clamp(0.70rem, 2.8vw, 0.85rem);
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
  word-break: break-word;
}

@media (max-width:480px){
  .kyc-loading-message-small {
    max-width: 85vw;
  }
}

/* Estilos específicos para el modal de préstamos participativos - solo móvil */
@media screen and (max-width: 768px) {
  ::ng-deep .custom-swal-width .swal2-title {
    font-size: 1.1rem !important;
    line-height: 1.2 !important;
  }
  
  ::ng-deep .custom-swal-width .swal2-html-container {
    font-size: 0.85rem !important;
    line-height: 1.3 !important;
    text-align: left !important;
  }
  
  ::ng-deep .custom-swal-width .swal2-html-container p {
    font-size: 0.85rem !important;
    margin-bottom: 0.8rem !important;
    text-align: left !important;
  }
  
  ::ng-deep .custom-swal-width .swal2-html-container label {
    font-size: 0.8rem !important;
  }
  
  ::ng-deep .custom-swal-width .swal2-html-container div {
    display: flex !important;
    align-items: center !important;
    gap: 0.5rem !important;
  }
  
  ::ng-deep .custom-swal-width .swal2-confirm {
    font-size: 0.85rem !important;
    padding: 0.4rem 1.2rem !important;
  }
}

@media screen and (max-width: 1024px) {
.iframe-container {
  min-height: 90vh;
}
}

@media (max-width: 600px) {
  .iframe-container {
    width: 100vw !important;
    min-height: 98vh !important;
    height: 98vh !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    background: #000;
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
  }
  .iframe-container iframe {
    width: 100vw !important;
    height: 98vh !important;
    min-height: 98vh !important;
    border-radius: 0 !important;
    background: #000;
    position: relative;
    display: block;
  }
}

.kyc-address-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

gmp-place-autocomplete.kyc-address-autocomplete {
  width: 100%;
  display: block;
  color-scheme: light !important;
  --color-scheme: light !important;
}

gmp-place-autocomplete.kyc-address-autocomplete::part(input) {
  width: 100%;
  padding: 0.625rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  color: #495057 !important;
  background-color: #fff !important;
  -webkit-text-fill-color: #495057 !important;
}

.manual-link {
  font-weight: 600;
  font-size: 0.95rem;
}

.manual-link a {
  color: #f09502;
  text-decoration: none;
}

.manual-link a:hover {
  text-decoration: underline;
}

.selected-address-display .alert {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.9rem;
  padding: 0.65rem 0.75rem;
}

@media (max-width: 576px) {
  .kyc-address-input-wrapper {
    gap: 0.5rem;
  }

  .manual-link {
    text-align: center;
  }

  .selected-address-display .alert {
    font-size: 0.85rem;
    flex-direction: column;
    align-items: flex-start;
  }
}

/* Asegura que el desplegable de Google Autocomplete siempre cubra el modal */
::ng-deep .pac-container {
  z-index: 2147483647 !important; /* mayor que cualquier overlay del sitio */
  position: absolute !important;
}

::ng-deep .pac-container .pac-item {
  font-family: 'Montserrat', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/modal-kyc/kyc-register/kyc-register.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW,EAAE,0CAA0C;EACvD,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,iCAAiC;EACjC,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;AACzB;;;AAGA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;GAClB,sBAAsB;AACzB;AACA;;;;;;;GAOG;AACH;AACA,YAAY;AACZ,aAAa;AACb,UAAU;AACV,gBAAgB;AAChB,kBAAkB;AAClB,WAAW;AACX;AACA;AACA,eAAe,EAAE,kBAAkB;AACnC;AACA;AACA,yBAAyB,EAAE,uCAAuC;AAClE;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,yBAAyB;AACzB,kBAAkB;AAClB,kBAAkB;AAClB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,6BAA6B;AAC7B,yBAAyB;AACzB,kBAAkB;AAClB,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,eAAe;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B,IAAI,yCAAyC;EACxE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B,EAAE,sCAAsC;EACtE,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;;EAEE,2BAA2B,EAAE,4BAA4B;EACzD,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB,EAAE,yDAAyD;AAC/E;;AAEA,6DAA6D;AAC7D;EACE;IACE,kCAAkC,EAAE,6DAA6D;EACnG;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,6BAA6B,EAAE,kCAAkC;IACjE,gBAAgB,gBAAgB,yDAAyD;IACzF,cAAc;EAChB;EACA,8EAA8E;EAC9E;IACE,8BAA8B,EAAE,iDAAiD;EACnF;EACA;IACE,gBAAgB,EAAE,yCAAyC;IAC3D,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,+EAA+E;AAC/E;EACE;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,iCAAiC;EACnC;AACF;;AAEA;AACA;EACE,gBAAgB;AAClB;AACA;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,0BAA0B;IAC1B,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,6EAA6E;AAC7E;EACE,8BAA8B,EAAE,0CAA0C;EAC1E,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".frontProgress{\n  position: absolute;\n  top: 0px;\n}\n\n.iconProgress{\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.register-header{\n  display: flex;\n  justify-content: space-around;\n}\n\n.btn {\n  width: 60px; /* Cambia '100px' al ancho que prefieras */\n  /* height: 50px;  Cambia '50px' a la altura que prefieras */\n  display: inline-block;\n}\n\n/* Estilos para los botones SÍ/NO en KYC Register */\n.btn-outline-dark {\n  border: 1px solid #333 !important;\n  background-color: white !important;\n  color: #333 !important;\n  padding: 10px 20px !important;\n  font-weight: bold !important;\n  font-family: 'Montserrat', sans-serif !important;\n}\n\n.btn-outline-dark:hover {\n  background-color: #f8f9fa !important;\n  border-color: #333 !important;\n  color: #333 !important;\n}\n\n.btn-dark {\n  background-color: #333 !important;\n  border: 1px solid #333 !important;\n  color: white !important;\n  padding: 10px 20px !important;\n  font-weight: bold !important;\n  font-family: 'Montserrat', sans-serif !important;\n}\n\n.btn-dark:hover {\n  background-color: #555 !important;\n  border-color: #555 !important;\n  color: white !important;\n}\n\n\n.custom-checkbox .mat-checkbox-frame {\n  border-color: #b0b0b0 !important;\n}\n\n.iframe-container {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  padding-top: 56.25%;\n   /* min-height: 90vh; */\n}\n/* .iframe-container {\nwidth: 100%;\nmin-height: 90vh;\n}\n\n.iframe-container body {\noverflow: scroll;\n} */\n.inputfile {\nwidth: 0.1px;\nheight: 0.1px;\nopacity: 0;\noverflow: hidden;\nposition: absolute;\nz-index: -1;\n}\n.inputfile + label {\ncursor: pointer; /* \"hand\" cursor */\n}\n.inputfile + label:hover {\nbackground-color: #000000; /* change background color when hover */\n}\n\n.card-file{\nwidth: 82px;\nheight: 82px;\nbackground-color: #ededed;\nborder-radius: 6px;\nposition: relative;\n}\n\n.add-file{\nwidth: 82px;\nheight: 82px;\nbackground-color: transparent;\nborder: 1px solid #ff9600;\nborder-radius: 6px;\nposition: relative;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\ncursor: pointer;\n}\n\n.info-tooltip{\n  background-color: #d9d9d9;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: small;\n  cursor: pointer;\n}\n\n/* Forzamos el ancho del contenedor interno del ng‑select */\n.country-prefix-select .ng-select-container {\n  width: 100px !important;\n  min-width: 100px !important;\n  min-height: 45px !important;   /* iguala altura al input .form-control */\n  height: 45px !important;\n  display: flex !important;\n  align-items: center !important; /* centra verticalmente el contenido */\n  padding: 0 12px !important;\n}\n\n/* Mejora visual del prefijo: separa bandera y código, aumenta legibilidad */\n.country-prefix-select .ng-value-label,\n.country-prefix-select .ng-option-label {\n  margin-left: 6px !important; /* espacio tras la bandera */\n  letter-spacing: 0.3px;\n}\n.country-prefix-select .flag-icon {\n  margin-right: 6px;\n}\n.country-prefix-select .ng-select-container {\n  font-size: 0.95rem; /* hace el prefijo ligeramente mayor en móvil y desktop */\n}\n\n/* Alinear prefijo y número en la misma línea solo en móvil */\n@media screen and (max-width: 480px) {\n  .row.my-5.pb-4 {\n    align-items: flex-start !important; /* alinea por la parte superior para evitar saltos visuales */\n  }\n  .row.my-5.pb-4 .col-auto,\n  .row.my-5.pb-4 .col {\n    padding-bottom: 0 !important;\n  }\n  .row.my-5.pb-4 label {\n    margin-bottom: 4px !important; /* reduce separación label-input */\n    min-height: 48px;               /* iguala altura de labels (maneja casos de 1-2 líneas) */\n    display: block;\n  }\n  /* Reserva espacio fijo para el mensaje de error del teléfono y evita saltos */\n  .row.my-5.pb-4 .col input.form-control {\n    margin-bottom: 32px !important; /* reserva extra para mensajes de varias líneas */\n  }\n  .row.my-5.pb-4 .col .text-danger.mt-1 {\n    min-height: 28px; /* altura mínima para 2 líneas de error */\n    display: block;\n  }\n  .row.my-5.pb-4 .col .text-danger.mt-1 {\n    margin-top: 2px !important;\n    line-height: 1.2 !important;\n  }\n}\n\n/* Reset and force ng-select styles */\n::ng-deep .ng-select:not(.country-prefix-select) {\n  display: block !important;\n  width: 100% !important;\n}\n\n::ng-deep .ng-select:not(.country-prefix-select) .ng-select-container {\n  min-height: 38px !important;\n  width: 100% !important;\n  position: relative !important;\n}\n\n::ng-deep .ng-dropdown-panel {\n  position: absolute !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n  left: 0 !important;\n}\n\n::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items {\n  box-sizing: border-box !important;\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n::ng-deep .ng-select .ng-select-container .ng-value-container {\n  width: 100% !important;\n  padding: 0.375rem 0.75rem !important;\n  box-sizing: border-box !important;\n}\n\n::ng-deep .ng-select:not(.country-prefix-select) .ng-dropdown-panel {\n  width: 100% !important;\n  min-width: 100% !important;\n  transform: none !important;\n  margin: 0 !important;\n  box-sizing: border-box !important;\n}\n\n::ng-deep .ng-dropdown-panel .scroll-host {\n  width: 100% !important;\n  min-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n::ng-deep .ng-option {\n  box-sizing: border-box !important;\n  width: 100% !important;\n  white-space: normal !important;\n  padding: 0.375rem 0.75rem !important;\n}\n\n.kyc-loading-message-small {\n  display: block;\n  margin-top: 6px;\n  font-weight: 400;\n  line-height: 1.25;\n  text-align: center;\n  color: #666;\n  font-size: clamp(0.70rem, 2.8vw, 0.85rem);\n  max-width: 320px;\n  margin-left: auto;\n  margin-right: auto;\n  word-break: break-word;\n}\n\n@media (max-width:480px){\n  .kyc-loading-message-small {\n    max-width: 85vw;\n  }\n}\n\n/* Estilos específicos para el modal de préstamos participativos - solo móvil */\n@media screen and (max-width: 768px) {\n  ::ng-deep .custom-swal-width .swal2-title {\n    font-size: 1.1rem !important;\n    line-height: 1.2 !important;\n  }\n  \n  ::ng-deep .custom-swal-width .swal2-html-container {\n    font-size: 0.85rem !important;\n    line-height: 1.3 !important;\n    text-align: left !important;\n  }\n  \n  ::ng-deep .custom-swal-width .swal2-html-container p {\n    font-size: 0.85rem !important;\n    margin-bottom: 0.8rem !important;\n    text-align: left !important;\n  }\n  \n  ::ng-deep .custom-swal-width .swal2-html-container label {\n    font-size: 0.8rem !important;\n  }\n  \n  ::ng-deep .custom-swal-width .swal2-html-container div {\n    display: flex !important;\n    align-items: center !important;\n    gap: 0.5rem !important;\n  }\n  \n  ::ng-deep .custom-swal-width .swal2-confirm {\n    font-size: 0.85rem !important;\n    padding: 0.4rem 1.2rem !important;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n.iframe-container {\n  min-height: 90vh;\n}\n}\n\n@media (max-width: 600px) {\n  .iframe-container {\n    width: 100vw !important;\n    min-height: 98vh !important;\n    height: 98vh !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n    background: #000;\n    position: fixed !important;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n  }\n  .iframe-container iframe {\n    width: 100vw !important;\n    height: 98vh !important;\n    min-height: 98vh !important;\n    border-radius: 0 !important;\n    background: #000;\n    position: relative;\n    display: block;\n  }\n}\n\n.kyc-address-input-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\ngmp-place-autocomplete.kyc-address-autocomplete {\n  width: 100%;\n  display: block;\n  color-scheme: light !important;\n  --color-scheme: light !important;\n}\n\ngmp-place-autocomplete.kyc-address-autocomplete::part(input) {\n  width: 100%;\n  padding: 0.625rem 0.75rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  color: #495057 !important;\n  background-color: #fff !important;\n  -webkit-text-fill-color: #495057 !important;\n}\n\n.manual-link {\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.manual-link a {\n  color: #f09502;\n  text-decoration: none;\n}\n\n.manual-link a:hover {\n  text-decoration: underline;\n}\n\n.selected-address-display .alert {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.9rem;\n  padding: 0.65rem 0.75rem;\n}\n\n@media (max-width: 576px) {\n  .kyc-address-input-wrapper {\n    gap: 0.5rem;\n  }\n\n  .manual-link {\n    text-align: center;\n  }\n\n  .selected-address-display .alert {\n    font-size: 0.85rem;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n/* Asegura que el desplegable de Google Autocomplete siempre cubra el modal */\n::ng-deep .pac-container {\n  z-index: 2147483647 !important; /* mayor que cualquier overlay del sitio */\n  position: absolute !important;\n}\n\n::ng-deep .pac-container .pac-item {\n  font-family: 'Montserrat', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
